import React from "react";
import styles from "./Chat.module.css";

const ContactItem = ({ name, avatar_link, newChat, removeChat }) => (
  <div 
    className={styles.contact} 
    onClick={() => { 
      newChat();
      removeChat();
    }}
  >
    <div
      className={styles.avatar}
      style={{
        background: `url(${avatar_link}) #777`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <div className={styles.contactItem}>{name}</div>
  </div>
);

const Contacts = ({ contacts, newChat, removeChat }) => {
  return (
    <div className={styles.contacts}>
      {contacts.length === 0 && (
        <div className={styles.noChats}>
          <div> No chats! </div>
          <div>Click chat button on user's profile to start a chat</div>
        </div>
      )}
      {contacts.map((contact) => (
        <ContactItem
          key={contact.id}
          newChat={() => newChat(contact)}
          removeChat={removeChat}
          {...contact}
        />
      ))}
    </div>
  );
};

export default Contacts;
